import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Link from 'component/link.component';
import { Button } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import OpacityModal from 'component/opacity.modal.component';

class EditClippingModal extends PureComponent {
  render() {
    const { customStyle } = this.props;

    return (
      <>
        <Button
          startIcon={<DeleteIcon />}
          onClick={() =>
            this._editClippingModal && this._editClippingModal._show()
          }
          style={{
            marginRight: '0.5vw',
            color: 'white',
            backgroundColor: 'rgb(255,0,0)',
          }}
        >
          Apagar
        </Button>

        <OpacityModal
          modalRef={ref => (this._editClippingModal = ref)}
          title="Tem certeza que deseja remover este recorte?"
          containerStyle={{ padding: '20px 0', maxWidth: '80%' }}
        >
          {
            <div className="flex-column">
              <span style={{ margin: 20, marginBottom: 0 }}>
                Você estará excluindo este recorte da sua lista de recortes.
              </span>
              <div className="flex-row justify-end" style={{ maxWidth: 450 }}>
                <Button
                  className="component-focus self-align-center"
                  onClick={this.props.onOkBtn}
                  style={{
                    color: 'white',
                    backgroundColor: '#185335',
                    margin: '20px 20px 0 10px',
                    padding: '8px 15px',
                  }}
                >
                  Sim
                </Button>
                <Link
                  className=" self-align-center"
                  onClick={() => {
                    this.setState({}, this._editClippingModal._hide);
                  }}
                  text="Não"
                  style={{ color: 'black', margin: '20px 15px 0' }}
                />
              </div>
            </div>
          }
        </OpacityModal>
      </>
    );
  }
}

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, null)(EditClippingModal);
